import { Badge } from '@givebutter/primitives/badge';
import { faPlugCircleCheck } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalize } from 'lodash';
import { WorkflowStatus } from 'types/domain';

interface WorkflowStatusBadgeProps {
    status: WorkflowStatus;
}
const WorkflowStatusBadge = ({ status }: WorkflowStatusBadgeProps) => {
    return (
        <Badge
            color={status === 'active' ? 'success' : 'neutral'}
            className="flex-shrink-0"
            size="sm"
        >
            {status === 'active' ? <FontAwesomeIcon icon={faPlugCircleCheck} size="sm" /> : null}
            {capitalize(status)}
        </Badge>
    );
};

export { WorkflowStatusBadge };
export type { WorkflowStatusBadgeProps };
